import React, { useEffect, useState } from 'react';
import { Button, Toast } from 'antd-mobile';
import { Checkbox } from 'antd-mobile-v5';
import TitleComponent from '../comm/title/title';
import styles from '../diseases/diseases.module.scss';
import { ApiCore } from '../../../api';
import IconUser from '../../../static/images/icon_user.png';

const api = new ApiCore();

function DiseasesComponent(props: any) {
    // 当前值 
    const [values, setValues] = useState<any>([])
    const [data, setData] = useState<any>([])
    const [userId, setUserId] = useState<any>('')
    // disabled值
    const [disableValue, setDisableValue] = useState<any>([])
    // 默认值
    const [defaultValue, setDefaultValue] = useState<any>([])
    const [appUrl, setAppUrl] = useState<any>('')
    const [uid, setUid] = useState<any>('')

    useEffect(() => {
        //设置网页title
        document.title = '选择病种';

        let d = null
        let c = sessionStorage.getItem('currentUserData')
        if (c) {
            d = JSON.parse(c)
            setUserId(d.account)
            getList(d.account, d.appCode)
        }
    }, [])

    // 获取病种列表 
    const getList = (userId: any, appCode: any) => {
        
        let params = {
            userId,
            appCode,
        }
        
        api.GetDiseaseList(params).then(res => {
            
            if (res.code == '0') {
                setData(res.data.list)
                defaultList(res.data.list)
                setAppUrl(res.data.url)
                setUid(res.data.uid)
            }
            else {
                Toast.fail(res.message)
            }
        })
    }

    const defaultList = (data: any) => {
        let discodes: any = [], defcodes: any = [];
        data && data.length > 0 && data.map((i: any) => {
            // defaultFocus->edc 默认选中可更改，
            // focusStatus->医患 默认选中不可更改
            if (i.focusStatus) {
                discodes.push(i.diseaseCode)
            }

            if (i.focusStatus || i.defaultFocus) {
                defcodes.push(i.diseaseCode)
            }
        })
        setDisableValue(discodes)
        setDefaultValue(defcodes)
        setValues(defcodes)
    }

    // 选择好了
    const onOk = () => {
        let affirmData: any = null, currentData: any = null, createData: any = null, token: any = null;
        let affirmUserData = sessionStorage.getItem('affirmUserData')
        let currentUserData = sessionStorage.getItem('currentUserData')
        let createAccountData = sessionStorage.getItem('createAccountData')
        let tokenData = sessionStorage.getItem('token')

        if (affirmUserData) {
            affirmData = JSON.parse(affirmUserData)
        }
        if (currentUserData) {
            currentData = JSON.parse(currentUserData)
        }
        if (createAccountData) {
            createData = JSON.parse(createAccountData)
        }

        if (tokenData) {
            token = JSON.parse(tokenData)
        }

        let params = {
            account: currentData ? currentData.account : '',
            accountType: currentData ? currentData.accountType : '',
            diseases: values,

            department: createData ? createData.department : '',
            hospital: createData ? createData.hospital : '',
            name: createData ? createData.name : '',
            tenantCode: token ? token.tenantCode : '',
            title: createData ? createData.title : '',
        }

        // 病种关注
        api.GetDiseaseFollow(params).then(res => {
            if (res.code == '0') {
                let paramsData = {
                    appCode: currentData.appCode || '',
                    appUserId: affirmData.userCode || '',
                }

                if (currentData.password) {
                    paramsData['username'] = currentData.account
                    paramsData['password'] = currentData.password
                } else {
                    paramsData['phone'] = affirmData.phone
                }

                let paramsList: any = []
                paramsList.push(paramsData)

                // 注册&&绑定
                api.MiddleAccountBind(paramsList).then(res => {
                    if (res.code == '0') {
                        // window.location.href = appUrl
                        if (res.data.uid == '' || res.data.uid == null) {
                            Toast.fail('绑定失败，未获得联合ID')
                            return
                        }
                        window['wx'].miniProgram.navigateTo({
                            url: `/pages/loading/loading?uid=${res.data.uid}`,
                            success: function(e: any){
                                console.log('e:',e)
                            },
                            fail: function(e: any) {
                                console.log('e:',e)
                            }
                        })
                    }
                    else {
                        Toast.fail(res.message)
                    }
                })
            }
            else {
                Toast.fail(res.message)
            }
        })
    }

    const onChange = (val: any) => {
        setValues(val)
    }

    return (
        <div className={'content_wrap'}>
            <div className={styles.DiseasesContent}>
                <TitleComponent title='请选择您感兴趣的病种' subTitle={'为您推荐专业的诊疗工具和内容'} />

                <div className={styles.userInfoWrap}>
                    <Checkbox.Group
                        defaultValue={defaultValue}
                        value={values}
                        onChange={onChange}
                    >
                        {
                            data.length > 0 && data.map((i: any, index: any) => (
                                <div className={styles.item} key={index} style={{marginRight: '4%'}}>
                                    <Checkbox 
                                        value={i.diseaseCode} 
                                        disabled={disableValue.includes(i.diseaseCode)}
                                    >
                                        <img src={i.iconUrl} alt='' className={styles.icon} />
                                        <div className={styles.txt}>{i.name}</div>
                                    </Checkbox>
                                </div>
                            ))
                        }
                    </Checkbox.Group>
                </div>

                <div className={styles.buttonGroup}>
                    <Button
                        className={`${styles.btn}`}
                        type="primary"
                        onClick={() => onOk()}
                        disabled={values.length == 0}
                    >
                        选择好了
                    </Button>
                </div>
            </div>

        </div>
    )

}

export default DiseasesComponent;